export class Constant {

  public static BaseUrl = window.location.protocol + "//" + window.location.hostname
  public static usertoken = sessionStorage.getItem('ut');
  public static x_ob_bypass = '1';

  /*------------------------------------------access url on hpre-------------------------------------------- */
  // public static hpre_BaseUrl = 'https://hpre.adityabirlahealth.com/GroupRenewal'; // access on hpre
  // public static hservice_base_url = 'https://hpre.adityabirlahealth.com/hServices/api/'// access on hpre 
  // public static x_ob_at = 'p0tzzQYkT70L2WYZ9ROwyHw0ZVVRfpeC4oy1tsufl71IKATgkh1HArjofyuZNi8Ul4vYwoJHqhO7S4yvdZXEzE'; // access on hpre
  // // access on hpre
  // public static header = {
  //   'Content-Type': 'application/json',
  //   'Accept': 'application/json',
  //   'Access-Control-Allow-Headers': 'Content-Type',
  //   'x-ob-bypass': Constant.x_ob_bypass,
  //   'x-ob-at': 'p0tzzQYkT70L2WYZ9ROwyHw0ZVVRfpeC4oy1tsufl71IKATgkh1HArjofyuZNi8Ul4vYwoJHqhO7S4yvdZXEzE',
  //   'x_ob_ut': Constant.usertoken
  // };
  /*------------------------------------------access url on hpre end-------------------------------------------- */

  /*------------------------------------------access url on prod-------------------------------------------- */
   public static hpre_BaseUrl = 'https://www.adityabirlacapital.com/healthinsurance/AbhiGroupRenewalAPI';  // access on prod

   public static hservice_base_url = 'https://www.adityabirlacapital.com/hServices/api/' //access on prod

   public static x_ob_at = '2REc8V4pyRaVyg67Odbv0pVS98CwoT32oNLCuJdVoT6N0QehNvoyq68s09174rDN2mc1sQB9g6VKs1'; // access on prod
  // access on prod
    public static header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'x-ob-at': '2REc8V4pyRaVyg67Odbv0pVS98CwoT32oNLCuJdVoT6N0QehNvoyq68s09174rDN2mc1sQB9g6VKs1',
      'x-ob-ut': Constant.usertoken
    };
  /*------------------------------------------access url on prod end----------------------------------------- */
}

